import React from 'react';
import { render } from 'react-dom';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';

let defaultState = {
	keys: [],
	saveid: 'default',
	history: [],
}


let requestKeysAction = function() {
	return function(dispatch, getState) {
		RecorderAPI.keys().then((keys) => {
			dispatch({type: "UPDATE_KEYS", keys: keys});
		}).catch((e) => console.exception(e));
	};
}

let loadKeyAction = function(ident) {
	return function(dispatch, getState) {
		RecorderAPI.load(ident).then((result) => {
			dispatch({type: "SET_HISTORY", history: result});
		}).catch((e) => console.exception(e));
	};
}

let saveKeyAction = function(ident, json) {
	return function(dispatch, getState) {
		RecorderAPI.save(ident, json).then((result) => {
			console.log("Gespeichert!");
		}).catch((e) => console.exception(e));
	};
}

let recorderReducer = function(state=defaultState, action) {

	switch ( action.type ) {
		case 'RECORD_ACTION':
			let now = +new Date();

			let add_action = {
				...action.action,
				__time: now,
				__duration: state.history[0] ? (now - state.history[state.history.length - 1].__time) : 0,
			};

			state = { ...state, history: [...state.history, add_action] }
			break;

		case 'UPDATE_KEYS':
			state = { ...state, keys: action.keys }
			break;

		case 'SET_SAVEID':
			state = { ...state, saveid: action.saveid }
			break;

		case 'SET_HISTORY':
			state = { ...state, history: action.history }
			break;
	}

	return state;
}


export class Recorder {

	constructor(app_store) {
		this.render = this.render.bind(this);
		this.runBot = this.runBot.bind(this);
		this.runBotLoop = this.runBotLoop.bind(this);

		this.node = document.getElementById('recorder');
		this.app_dispatch = null;

        this.store = createStore(
        	recorderReducer,
            applyMiddleware(thunk)
        );

        this.store.dispatch(requestKeysAction());

        this.store.subscribe(this.render);
        this.render();
	}

	render() {
		let state = this.store.getState();

		let onChange = (saveid) => this.store.dispatch({type: 'SET_SAVEID', saveid})

        render(
            <RecorderHistoryPopup
            	{...state}
            	onChange={onChange}
            	dispatch={this.store.dispatch}
            	runBot={this.runBot}
            />,
            this.node
        );
	}

	runBotFast() {

	}

	runBot(method) {
		this.fakeActions = this.store.getState().history.slice();
		this.botMethod = method;
		this.runBotLoop();
	}

	runBotLoop() {
	    let action = this.fakeActions.shift();
	    console.log(action);
	    this.app_dispatch(action);
	    if ( this.fakeActions.length > 0 ) { 
	    	let delay = 300;
	    	if ( this.botMethod === "real" && this.fakeActions[1] ) {
	    		delay = this.fakeActions[1].__duration;
	    	}
	    	setTimeout(this.runBotLoop, delay);
	    }
	}

}


let RecorderAPI  = {

	keys: function() {
		return fetch("http://localhost:3002/keys/", {cache: "no-cache"}).then((r) => r.json()).then((r) => r.keys);
	},

	load: function(ident) {
		return fetch("http://localhost:3002/keys/" + ident, {cache: "no-cache"}).then((r) => r.json());
	},

	save: function(ident, json) {
		let data = new FormData;
		data.set("json", json);

		return fetch("http://localhost:3002/keys/" + ident, {
			method: "POST",
			body: data,
		}).then((r) => r.json());

	},

}


const RecorderHistoryPopup = (props) => {
	let { history, keys, saveid, onChange, runBot, dispatch } = props;

	let json = JSON.stringify(history);

	let onChangeInput = (e) => onChange(e.currentTarget.value);
	let onChangeSelect = (e) => onChange(e.currentTarget.options[e.currentTarget.selectedIndex].value);

	return (
		<div className="wrapper">
			<div className="left">

				<div className="status">
					<span>{history.length} Aktionen</span><br />
					<span>{(json.length / 1024).toFixed(2)} KB</span>
				</div>

				<div className="control">
					<select onChange={onChangeSelect} value={saveid}>
						<option value="">- Select -</option>
						{keys.map((k, i) => <option key={i} value={k}>{k}</option>)}
					</select>
					<input type="saveid" onChange={onChangeInput} value={saveid} placeholder="Speicher-ID" />
					<button onClick={(e) => dispatch(loadKeyAction(saveid)) }>Laden</button>
					<button onClick={(e) => dispatch(saveKeyAction(saveid, json)) }>Speichern</button>
					<button onClick={() => runBot("fast")}>Test (schnell)</button>
					<button onClick={() => runBot("real")}>Test (Echtzeit)</button>
				</div>
			</div>

			<div className="right">
				<h4>Rekorder</h4>
				<textarea value={json} readOnly />
			</div>
		</div>
	);	
}

export const makeRecorderMiddleware = recorderStore => {
	return store => next => action => {

		recorderStore.dispatch({
			type: 'RECORD_ACTION',
			action: action,
		})

		return next(action);
	}
}



/** WEBPACK FOOTER **
 ** ../ibe/src/Recorder.js
 **/